function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-36.4%",
  y: "-7.1%",
  width: "172.7%",
  height: "114.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "General-01,-10~14",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-\\u9996\\u9801_p",
  transform: "translate(-1378.000000, -315.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "index_banner",
  transform: "translate(0.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  filter: "url(#filter-1)",
  transform: "translate(1389.000000, 271.000000) scale(-1, 1) translate(-1389.000000, -271.000000) translate(1378.000000, 215.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1733289,111 C18.370865,111 17.6622792,110.480841 17.4270427,109.719874 L1,56.5843761 L17.4240865,2.27821785 C17.719328,1.3277878 18.7320489,0.791327145 19.692617,1.07652702 C20.6531852,1.3617269 21.2021598,2.36186659 20.9223394,3.3168753 L4.81531688,56.5731076 L20.9196151,108.658852 C21.2145997,109.615441 20.6723693,110.628184 19.7081642,110.921523 C19.5347046,110.97344 19.354514,111 19.1733289,111 L19.1733289,111 Z",
  id: "btn_arrow_banner"
})))));

function SvgBtnArrowBannerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "112px",
    viewBox: "0 0 22 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn_arrow_banner_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowBannerRight);
export default __webpack_public_path__ + "static/media/btn_arrow_banner_right.34d0cc6b.svg";
export { ForwardRef as ReactComponent };